var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-card" }, [
    _c(
      "div",
      { staticClass: "setting-header" },
      [
        _c("a-icon", {
          staticClass: "setting-icon",
          attrs: { type: _vm.icon },
        }),
        _vm._v(" "),
        _c("h5", { staticClass: "setting-title" }, [_vm._v(_vm._s(_vm.title))]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "setting-content" },
      [
        _vm._t("default", function () {
          return [
            _c("div", { staticClass: "setting-value-wrapper" }, [
              _c("div", { staticClass: "setting-value" }, [
                _vm._v(_vm._s(_vm.value)),
              ]),
              _vm._v(" "),
              _vm.subValue
                ? _c("div", { staticClass: "setting-sub-value" }, [
                    _vm._v(_vm._s(_vm.subValue)),
                  ])
                : _vm._e(),
            ]),
          ]
        }),
        _vm._v(" "),
        !_vm.$slots.default && _vm.value
          ? _c("a-button", {
              staticClass: "edit-button",
              attrs: {
                type: "primary",
                shape: "circle",
                icon: "edit",
                size: "small",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("edit")
                },
              },
            })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }